module.exports = __webpack_public_path__ + "assets/0563ec2ed50f503306e0fe08a43ca3f6.mp3";